/**
 * @author Harish.R <harish.r@314ecorp.com>
 * @description Edit KeycloakUser Button
 */
import { Link } from 'react-router-dom';
import { Button, Tooltip } from 'antd';
import { Edit } from '@icon-park/react';

import { getEditKeycloakUserPath } from 'utils/router';
import { useAppStoreValues } from 'store/app';
import { NO_ACCESS_TOOLTIP_TEXT } from '@veritable/common/constants';

/**
 * EditKeycloakUser
 *
 */
const EditKeycloakUser: React.FC<Record<'details', UserManagement.IUserResponseModel>> = ({ details }) => {
	const { canEditUsers } = useAppStoreValues().userAccess;
	const userID = details?.id ?? '';

	const editButton = (
		<Tooltip title={`${canEditUsers ? 'Edit User' : NO_ACCESS_TOOLTIP_TEXT}`}>
			<Button color='default' icon={<Edit />} disabled={!canEditUsers} />
		</Tooltip>
	);

	if (userID && canEditUsers) {
		return (
			<Link key='edit-provider' id={userID} to={getEditKeycloakUserPath(userID)}>
				{editButton}
			</Link>
		);
	}

	return editButton;
};

export default EditKeycloakUser;
